import storageHelper from "../helpers/storage-helper";

export const JWT_TOKEN = storageHelper.get('jwt_token');